// extracted by mini-css-extract-plugin
module.exports = {"mainPanelContainer":"OCRScopingJobMainPanel__mainPanelContainer___LXwPJ"};